import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { convertBemToCamel } from '../../helpers';
import styles from './ContentContainer.module.scss';

export type ContentContainerProps = PropsWithChildren<{
  size?: 'l' | 'm' | 's';
  padding?: boolean;
}>;

export const ContentContainer = ({
  size = 'l',
  padding = true,
  children,
}: ContentContainerProps) => {
  const classes = clsx(
    styles.base,
    styles[convertBemToCamel(`size--${size}`)],
    {
      [styles.padding]: padding,
    }
  );

  return <div className={classes}>{children}</div>;
};
